import {DeepPartial} from 'utility-types';

import {defaultTo} from 'ramda';

import {GetDirectSaleVariantResponse} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../types/WarehouseDirectSaleVariantsDetailFormSchema';
import {
  buildPaymentDocumentsDefaultValues,
  InvoiceTemplateResolvers,
} from './buildPaymentDocumentsDefaultValues';

type DocumentsDefaultValues = NonNullable<
  DeepPartial<WarehouseDirectSaleVariantsDetailFormSchemaType>['documents']
>;

export function buildDocumentsDefaultValues(
  documents: GetDirectSaleVariantResponse['documents'] | Nullish,
  resolvers: InvoiceTemplateResolvers
): DocumentsDefaultValues {
  return {
    ...documents,
    fastTrackIssue: {
      ...documents?.fastTrackIssue,
      isEnable: defaultTo(false, documents?.fastTrackIssue?.isEnable),
    },
    ...buildPaymentDocumentsDefaultValues(documents, resolvers),
  };
}
